import GradientCard from "components/Common/GradientCard";
import { PiStorefrontFill, PiUsersFill, PiMoneyFill } from "react-icons/pi";

interface ICommunityStatsProps {
  businessOverallStats: BusinessOverallStatsType | null;
}

const CommunityStats: React.FC<ICommunityStatsProps> = ({
  businessOverallStats: feedback,
}) => {
  return (
    <GradientCard
      topBorderColor="primary"
      sideGradientColors={{ from: "#3B82F6", to: "#8B5CF6" }} 
      className="w-full h-full"
    >
      <div className="min-h-[200px] p-6 flex flex-col justify-center">
        <div className="text-lg font-semibold text-black mb-4">
          Join thousands of businesses thriving with Open Rewards!
        </div>
        <div className="space-y-3">
          <div className="flex items-center gap-3">
            <span className="text-2xl text-limeGreen"><PiUsersFill/></span>
            <span className="text-lg font-bold ">
              {feedback?.totalUsersCount}
            </span>
            <span className="text-gray-700">shoppers using Open Rewards</span>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-2xl text-green"><PiMoneyFill/></span>
            <span className="text-lg font-bold text-green-600">
              ${feedback?.totalAmountSpent}
            </span>
            <span className="text-gray-700">spent through Open Rewards</span>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-2xl text-blue-600"><PiStorefrontFill/></span>
            <span className="text-lg font-bold ">
              {feedback?.totalBusinessesCount}
            </span>
            <span className="text-gray-700">local businesses supported</span>
          </div>
        </div>
      </div>
    </GradientCard>
  );
};

export default CommunityStats;
